<template>
  <div id="particularite">
    <h2>Modifier la particularité</h2>
    <div v-if="particularite.id !== undefined">
      <div class="form-group">
        <label style="color: black" class="col-form-label mb-5" for="titre">Titre</label>
        <input
          style="color: black"
          v-model="particularite.titre"
          type="text"
          class="form-control"
          placeholder="Titre"
          id="titre"
        />
      </div>
      <div class="form-group">
        <label style="color: black" class="col-form-label" for="date">Date</label>
        <input
          style="color: black"
          v-model="particularite.date"
          type="date"
          class="form-control"
          placeholder="Date"
          id="date"
        />
      </div>
      <div class="form-group" v-for="site of sites" :key="site.id">
        <div class="custom-control custom-switch">
          <input
            type="checkbox"
            class="custom-control-input"
            :id="`switchSite${site.id}`"
            v-model="checkedSites[site.id]"
          />
          <label class="custom-control-label" :for="`switchSite${site.id}`">{{site.nom}}</label>
        </div>
      </div>
      <div class="form-group">
        <label for="contenu">Contenu</label>
        <textarea v-model="particularite.contenu" class="form-control" id="contenu" rows="10"></textarea>
      </div>
      <button @click="save()" class="btn btn-primary mr-3">
        <font-awesome-icon :icon="'save'" />&nbsp;Enregistrer les modifications
      </button>
      <router-link style="color: white" class="btn btn-danger" to="/horaires/partic">Annuler</router-link>
    </div>
    <div v-else>
      <p>Element introuvable. Impossible de la modifier.</p>
    </div>
  </div>
</template>
<script>
import api from "@/api";
import utils from "@/utils";
import moment from "moment";
import Swal from "sweetalert2";

export default {
  data() {
    return { particularite: { site: [] }, sites: [], checkedSites: [] };
  },
  async created() {
    this.$store.commit("setLoading", true);
    this.sites = (await api.getSites()).data.sites;
    let response = await api.getParticulariteById(this.$route.params.id);
    if (response.code === 200) {
      this.particularite = response.data.particularite;
      this.particularite.date = moment(this.particularite.date).format("YYYY-MM-DD");
      for (let site of this.particularite.sites) {
        this.checkedSites[site] = true;
      }
    }
    this.$store.commit("setLoading", false);
  },
  methods: {
    async save() {
        let sites = [];
        for (let index in this.checkedSites){
            if(this.checkedSites[index]) { sites.push(index); }
        }
        this.particularite.sites = sites;
        let response = await api.modifyParticularite(this.particularite);
        await Swal.fire({
            type: response.code === 200 ? "success" : "error",
            title: response.message
        }).then(()=>{
            this.$router.push('/horaires/partic');
        });
    }
  }
};
</script>